import Link from 'components/link/Link';

import { ILink } from 'source/NFR.types';

const SectionTitle: React.FC<{ sectionLink: ILink }> = ({ sectionLink }) => {
  return <Link theme="actionLink" {...sectionLink} />;
};

SectionTitle.displayName = 'SectionTitle';

export default SectionTitle;
